<template>
  <div class="page bg-white">
    <div class="fixed-top bg-white flex justify-around">
      <!--   是否匿名   -->
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item btn-select-sort " @click="anonymousColumn.show = true">是否匿名：{{ isAnonymousTitle }}<span
            class="caret"></span></div>
      </div>
      <!--   显示状态   -->
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item btn-select-sort " @click="showColumn.show = true">显示状态：{{ isShowTitle }}<span
            class="caret"></span></div>
      </div>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        style="margin-top: 40px"
        @load="loadData">
      <van-cell-group class="order-list">
        <van-cell v-for="(item, index) in list" :key="index" size="large" center clickable is-link :to="'/leader/order/rate-detail/'+item.id">
          <div class="order-item">
            <div class="left align-center">
              <div class="padding-left-sm">
                <div style="display: flex;margin-left: 4px">
                  <van-image round width="40px" height="40px" :src="item.userHeadImgUrl"></van-image>
                  <span style="margin-left: 10px;margin-top:10px">{{ item.userNickname }}</span>
                </div>
                <div>
                  <van-tag v-if="item.orderType == 'assigned'" type="primary" plain >指定单</van-tag>
                  <van-tag v-if="item.orderType == 'random'" type="success" plain >随机单</van-tag>
                  <van-tag v-if="item.orderType == 'reward'" type="danger" plain >打赏单</van-tag>
                  <span v-if="isAuthority('order')" @click.stop.prevent="gotoOrderDetail(item.orderId)" style="margin-left: 10px;color: #1989fa" >{{item.orderNo}}</span>
                  <span v-else >{{item.orderNo}}</span>
                </div>
                <div>
                  <span>显示状态：</span>
                  <van-tag v-if="item.isShow" plain type="danger" style="margin-right: 5px">显示中</van-tag>
                  <van-tag v-if="!item.isShow" plain type="danger" style="margin-right: 5px">已隐藏</van-tag>
                  <van-tag v-if="item.isAnonymous" style="margin-left: 5px">匿名评价</van-tag>
                </div>
                <div v-if="$hasFeature('custom_2362')" class="row">
                  <div>评价分数：</div>
                  <div class="item">
                    <div>
                      <span class="label">服务：</span>
                      <van-rate
                          v-model="item.score"
                          readonly
                          :size="16"
                          color="#ffd21e"
                          void-icon="star"
                          void-color="#eee"
                      />
                    </div>
                    <div v-if="item.techScore > 0">
                      <span class="label">技术：</span>
                      <van-rate
                          v-model="item.techScore"
                          readonly
                          :size="16"
                          color="#ffd21e"
                          void-icon="star"
                          void-color="#eee"
                      />
                    </div>
                    <div v-if="item.intelligenceScore > 0">
                      <span class="label">情商：</span>
                      <van-rate
                          v-model="item.intelligenceScore"
                          readonly
                          :size="16"
                          color="#ffd21e"
                          void-icon="star"
                          void-color="#eee"
                      />
                    </div>
                    <div v-if="item.emoScore > 0">
                      <span class="label">情绪价值：</span>
                      <van-rate
                          v-model="item.emoScore"
                          readonly
                          :size="16"
                          color="#ffd21e"
                          void-icon="star"
                          void-color="#eee"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="!$hasFeature('custom_2362')" >
                  <span class="label">评价分数：</span>
                  <van-rate
                      v-model="item.score"
                      readonly
                      :size="16"
                      color="#ffd21e"
                      void-icon="star"
                      void-color="#eee"
                  />
                </div>
                <div class="box">评价内容：{{item.content}}</div>
                <div>
                  <span style="margin-right: 5px">评价时间：{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</span>
                </div>
              </div>
            </div>
          </div>

        </van-cell>
      </van-cell-group>
    </van-list>
    <!-- 选择日期 -->
    <van-popup
        v-model="datetimePickerPopupShow"
        class="datetime-picker-popup"
        position="bottom"
    >
      <van-datetime-picker
          v-model="datetimePicker.value"
          type="date"
          :max-date="datetimePicker.maxDate"
          :formatter="datetimePickerFormatter"
          @confirm="datetimePickerConfirm"
          @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>
    <!--上拉选择申请状态-->
    <van-action-sheet
        v-model="anonymousColumn.show"
        :actions="anonymousColumn.actions"
        cancel-text="取消"
        @select="onAnonymousColumnChange"/>

    <!--上拉选择申请类型-->
    <van-action-sheet
        v-model="showColumn.show"
        :actions="showColumn.actions"
        cancel-text="取消"
        @select="onShowColumnChange"/>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Button,
  List,
  Cell,
  Tag,
  Icon,
  ActionSheet,
  Dialog,
  Image,
  Collapse,
  CollapseItem, Popup, DatetimePicker, Field,Rate
} from 'vant';
import { getOrderRateList } from '@/api/leader/order-rate'
import moment from 'moment';
import Decimal from 'decimal.js';

Vue.use(Tab)
    .use(Tabs)
    .use(Button)
    .use(List)
    .use(Cell)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Image)
    .use(Collapse)
    .use(CollapseItem)
    .use(Popup)
    .use(DatetimePicker)
    .use(Field)
    .use(Rate)

export default {
  name: 'order-rate-list',
  components: {
  },
  computed:{
    isAnonymousTitle(){
      if (this.formModel.isAnonymous == 0) {
        return "不匿名"
      }
      if (this.formModel.isAnonymous == 1) {
        return "匿名"
      }
      return "全部"
    },
    isShowTitle(){
      if (this.formModel.isShow == 0) {
        return "已隐藏"
      }
      if (this.formModel.isShow == 1) {
        return "显示中"
      }
      return "全部"
    },
  },
  data () {
    return {
      activeNames: [1],
      datetimePicker: {
        field: null,
        value: null,
        maxDate: moment().add('3', 'month').toDate()
      },
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },

      anonymousColumn: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '匿名', value: 1},
          {name: '不匿名', value: 0},
        ]
      },
      showColumn: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '显示中', value: 1},
          {name: '已隐藏', value: 0},
        ]
      },
      formModel: {
        orderId: null,
        userId: null,
        clerkId: null,
        content: null,
        isAnonymous: null,
        isAuto: null,
        isShow: null,
        createdStart: null,
        createdEnd: null
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  methods: {
    //判断权限
    isAuthority(catalogue){
      return this.$LeaderAccess.includes(catalogue)
    },
    gotoOrderDetail(orderId) {
      this.$router.push('/leader/order/detail/'+orderId)
    },
    change(){
      this.loadData(true)
    },
    openPicker(columns, onConfirm,onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if(!onCancel){
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    datetimePickerFormatter(field, value) {
      if (field === 'year') {
        return `${value}年`;
      } else if (field === 'month') {
        return `${value}月`
      } else if (field == 'day') {
        return `${value}日`
      }
      return value;
    },
    showDatetimePickerPopup(field) {
      this.datetimePicker.field = field
      if (field == 'start') {
        this.datetimePicker.value = moment(this.formModel.startTime).toDate()
      } else if (field == 'end') {
        this.datetimePicker.value = moment(this.formModel.endTime).toDate()
      }
      this.datetimePickerPopupShow = true;
    },
    datetimePickerConfirm(value) {
      this.datetimePickerPopupShow = false;
      if (this.datetimePicker.field == 'start') {
        this.formModel.startTime = moment(value).format('YYYY-MM-DD');
      } else if (this.datetimePicker.field == 'end') {
        this.formModel.endTime = moment(value).format('YYYY-MM-DD');
      }
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    onAnonymousColumnChange(item) {
      this.formModel.isAnonymous = item.value
      this.anonymousColumn.show = false
      this.loadData(true)
    },
    onShowColumnChange(item) {
      this.formModel.isShow = item.value
      this.showColumn.show = false
      this.loadData(true)
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getOrderRateList(
          this.formModel.orderId,
          this.formModel.userId,
          this.formModel.clerkId,
          this.formModel.content,
          this.formModel.isAnonymous,
          this.formModel.isAuto,
          this.formModel.isShow,
          this.formModel.createdStart,
          this.formModel.createdEnd,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo ++
      })
    }
  },
  mounted() {

  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.page {
  padding-bottom: 100px;
}
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}

.order-item {
  display: flex;
  align-items: center;
  .userMemo {
    color: #999;
  }
  .left {
    flex: 1;
    display: flex;
    .service-info {
      color: #333;
    }
    .created {
      color: #555;
      margin-bottom: 5px;
    }
    .user_head {
      position: relative;
      padding: 10px;
      .avatarFrame {
        position: absolute;
        top: 0;
        left: 0;
      }
      .level {
        position: absolute;
        left: 50%;
        height: 10px;
        font-size: 10px;
        white-space: nowrap;
        bottom: 0px;
        transform: translateX(-50%);
      }
    }
  }
  .right {
    text-align: right;
    min-width: 30px;
    .total-amount {
      color: #333;
    }
  }
}
.box {
  /* 限定范围 */
  width: 300px;
  max-height: 75px;
  /* 1.溢出隐藏 */
  overflow: hidden;
  /* 2.用省略号来代替超出文本 */
  text-overflow: ellipsis;
  /* 3.设置盒子属性为-webkit-box  必须的 */
  display: -webkit-box;
  /* 4.-webkit-line-clamp 设置为2，表示超出2行的部分显示省略号，如果设置为3，那么就是超出3行部分显示省略号 */
  -webkit-line-clamp: 3;
  /* 5.字面意思：单词破坏：破坏英文单词的整体性，在英文单词还没有在一行完全展示时就换行  即一个单词可能会被分成两行展示 */
  word-break: break-all;
  /* 6.盒子实现多行显示的必要条件，文字是垂直展示，即文字是多行展示的情况下使用 */
  -webkit-box-orient: vertical;
}
.row {
  display: flex;
  flex-direction: row !important;
  .item {
    display: flex;
    flex-direction: column !important;
  }
}
</style>
